import { render, staticRenderFns } from "./CertificateManage.vue?vue&type=template&id=714b3c5a&scoped=true&"
import script from "./CertificateManage.vue?vue&type=script&lang=js&"
export * from "./CertificateManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714b3c5a",
  null
  
)

export default component.exports